import baseRoute from '../baseRoute';

export default `${baseRoute}/scheduleBoard` as const;
